<template>
  <div id="app" v-cloak>
    <router-view/>

    <FooterNav/>
  </div>
</template>

<script>
import FooterNav from '@/components/molecules/Footer'

export default {
  components: {
    FooterNav
  }
}
</script>

<style lang="scss">
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
